// Capçalera única per a totes les fitxes/formularis "document" de l'ERP
// (Pressupost, Expedient Comercial, Comanda de client, Expedient de Taller...).
// Abans cada pantalla reimplementava la seva pròpia capçalera amb petites
// variacions (fons gris/blanc, botó "X" redundant amb "Cancel·lar", Estat en
// posicions diferents) — ara totes comparteixen aquest component.
import type { ReactNode } from 'react';

export default function DocumentHeader({ title, infoBadges, status, actions }: {
  title: ReactNode;
  infoBadges?: ReactNode;
  status?: ReactNode;
  actions: ReactNode;
}) {
  return (
    <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between flex-shrink-0">
      <div className="flex items-baseline gap-2 min-w-0 flex-wrap">
        <h1 className="text-2xl font-semibold text-gray-900 truncate">{title}</h1>
        {infoBadges}
        {status}
      </div>
      <div className="flex items-center gap-2 shrink-0">{actions}</div>
    </div>
  );
}

// Badges informatius de capçalera (Marca, Expedient...). Ordre estàndard
// acordat amb el client: Marca → Expedient → Pressupost → Estat (l'Estat es
// passa sempre a `status`, mai dins d'`infoBadges`).
const TONE_CLASSES: Record<string, string> = {
  brand: 'bg-blue-50 text-blue-700',
  expedient: 'bg-purple-50 text-purple-700',
  budget: 'bg-indigo-50 text-indigo-700',
  neutral: 'bg-gray-100 text-gray-600',
  success: 'bg-green-50 text-green-700',
};

export function HeaderBadge({ tone = 'neutral', title, children }: {
  tone?: keyof typeof TONE_CLASSES;
  title?: string;
  children: ReactNode;
}) {
  return (
    <span title={title} className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${TONE_CLASSES[tone]}`}>
      {children}
    </span>
  );
}

export function HeaderLinkBadge({ tone = 'neutral', href, title, children }: {
  tone?: keyof typeof TONE_CLASSES;
  href: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium hover:opacity-80 ${TONE_CLASSES[tone]}`}
    >
      {children}
    </a>
  );
}
